import { Component, Input, Injector, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { MessageService } from 'src/app/@shared/message/message.service';
import { CommonService } from 'src/app/@shared/services/common.service';
import { PusherService } from 'src/app/@shared/services/pusher.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { LoginComponent } from 'src/app/auth/login/login.component';
import Swal from 'sweetalert2';
declare var $: any;

@Component({
  selector: 'app-topnav',
  templateUrl: './topnav.component.html',
  styleUrls: ['./topnav.component.css']
})
export class TopnavComponent extends BaseClass<any> implements OnInit {

  @ViewChild('afterLoginModal', { static: false }) afterLoginModal?: ModalDirective;
  openafterLoginModal = false;


  public user: any;
  public menuItems: any;
  searchData: any[] = [];
  public isLoggedin = false;
  public _pusher!: PusherService;
  todayDate = new Date();
  public message: any = 'Welcome To Our Exchange';
  public wpLink = '';
  isChatIn: boolean = false;
  downloadDivStatus: boolean = true;

  constructor(public router: Router,
    public service: WebserviceService,
    public _common: CommonService,
    private _message: MessageService,
    private _shared: SharedService,
    public actRoute: ActivatedRoute,
    private injector: Injector) {
    super();

    this.downloadDivStatus = (this.getLocalItem('dwnApk')) ? false : true;

    this._shared.sharedLogin.subscribe((data: any) => {
      // this.userData = this.getLocalItem('user');
      // if (data && this.userData?.username.toLowerCase() != 'demo123' && this.env.host.afterLoginNoticePath != '') 
      //   this.showAfterLoginModal();
    });

    //this.user = this.getLocalItem('user');
    this.message = (localStorage.getItem(`${this.env.panel}marquee`)) ? localStorage.getItem(`${this.env.panel}marquee`) : this.message;

    const sub1 = this._shared.sharedLoginModal.subscribe((res: any) => {
      if (res && res?.login) {
        this.openLogin('');
        res = undefined;
      }
    });
    this.subs.push(sub1);

    const sub2 = this._shared.sharedSideMenu.subscribe((data: any) => {
      if (data && data?.menuAPICall) {
        this.menu = this.getLocalItem('menu');
        this.genMenuItems();
      }

    });
    this.subs.push(sub2);

    if (this._common.getToken()) {
      this._pusher = injector.get<PusherService>(PusherService);
      this._pusher.userAccUpdate().subscribe(res => {
        if (res) {
          if (res.msg != '') {
            this._message.errmessage(res.msg);
            setTimeout(() => {
              this._common.removeLocalstorage();
              this.router.navigate(['/home']);
              window.location.reload();
            }, 1000)
          }
          if (this.user) {
            this.user.balance = parseFloat(res?.balance) + parseFloat(res?.expose) + parseFloat(res?.pl);
            this.user.available_balance = parseFloat(res?.balance) + parseFloat(res?.expose) + parseFloat(res?.pl);
            this.user.expose = res?.expose;
            this.user.pl = res?.pl;
            localStorage.setItem(`${this.env.panel}user`, JSON.stringify(this.user));
          }
        }
      });
    }
  }

  ngOnInit(): void {
    // $('.button-menu-mobile').on("click", () => {
    //   $('body').toggleClass("sidebar-enable");
    // });

    this.menu = (localStorage.getItem(`${this.env.panel}menu`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}menu`) as any) : [];
    if (this.menu.length == 0) {
      this.getMenu();
      //console.log("innn");
    }


    // Topnav inplay counter
    let sideRaceM7 = (localStorage.getItem(`${this.env.panel}sideRaceMenu7`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}sideRaceMenu7`) as any) : [];
    let sideRaceM4339 = (localStorage.getItem(`${this.env.panel}sideRaceMenu4339`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}sideRaceMenu4339`) as any) : [];
    let hUpCommingRaceCount = this.findUpComingRace(sideRaceM7, 7).length;
    let gUpCommingRaceCount = this.findUpComingRace(sideRaceM4339, 4339).length;
    this.menu.forEach((menuEle: any, i: any) => {
      menuEle['in_play_count'] = 0;
      if (this.events.races.includes(menuEle.id)) {
        menuEle['in_play_count'] = (menuEle.id === 7) ? hUpCommingRaceCount : gUpCommingRaceCount;
      } else if (this.events.sports.includes(menuEle.id)) {
        menuEle['in_play_count'] = this.getEventInplayDataCount(menuEle.id);
      }
    });
    this.genMenuItems();

    if (this._common.getToken()) {
      this.isChatIn = true;
      this.getContactInfo();
    }
    // let dts = (localStorage.getItem(`${this.env.panel}sideMenu`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}sideMenu`) as any) : [];
    // this.searchData = dts;
    // $(function () {
    //   var body = $('body');
    //   $('[data-toggle="minimize"]').on("click", function () {
    //     if ((body.hasClass('sidebar-toggle-display')) || (body.hasClass('sidebar-absolute'))) {
    //       body.toggleClass('sidebar-hidden');
    //     } else {
    //       body.toggleClass('sidebar-icon-only');
    //     }
    //   });
    //   $('[data-toggle="offcanvas"]').on("click", function () {
    //     $('.sidebar-offcanvas').toggleClass('active')
    //   });
    // });
  }

  genMenuItems() {
    this.menuItems = this.menu;
    let index = this.menuItems.findIndex((item: any) => item.id === 99999);
    if (index !== -1) {
      this.menuItems.splice(index, 0, { "id": 883, "name": "Aviator" });
      this.menuItems.splice(index + 2, 0, { id: this.events.royalCasino[0], name: 'Royal Casino' },);
    }

    // this.menuItems = this.menuItems.map((item:any) => {
    //   item.name = item.name.replace(" Racing", ""); // Replace " Racing" with an empty string
    //   return item;
    // });
  }

  getEventInplayDataCount(event_type_id: any) {
    let sideM = (localStorage.getItem(`${this.env.panel}sideMenu`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}sideMenu`) as any) : [];
    const groupedInPlay = this.groupBy(sideM, (dat: any) => dat.in_play);
    //const groupedF = this.groupBy(data, (dat: any) => dat.featured_event);
    //let ip = [...groupedInPlay.get(1) ? groupedInPlay.get(1) : [], ...groupedF.get(1) ? groupedF.get(1) : []]
    let ip = [...groupedInPlay.get(1) ? groupedInPlay.get(1) : []]
    const uniqueArray = ip.filter((thing, index) => {
      const _thing = JSON.stringify(thing);
      return index === ip.findIndex(obj => {
        return JSON.stringify(obj) === _thing;
      });
    });
    const groupedCat = this.groupBy(uniqueArray, (dat: any) => dat.event_type_id);
    let inPlayEventTypeData = groupedCat.get(event_type_id) ? groupedCat.get(event_type_id) : [];

    return inPlayEventTypeData.length;
  }

  showAfterLoginModal() {
    // if (this.env.host.name == 'jannatbook247')
    if (localStorage.getItem(`${this.env.panel}JustL`)) {
      this.afterLoginModal?.show();
      this.openafterLoginModal = true;
      localStorage.removeItem(`${this.env.panel}JustL`);
    } else {
      console.log('out');
      this.openafterLoginModal = false;
    }
  }

  getMenu() {
    this.getServices().Get(`${this.env.baseUrl + this.api.menu}`).subscribe(
      (res) => {

        if (res.status == true) {
          if (!localStorage.getItem(`${this.env.panel}stakes`)) {
            localStorage.removeItem(`${this.env.panel}stakes`);
            localStorage.setItem(`${this.env.panel}stakes`, JSON.stringify(this.env.stakes));
          }
          this.array_move(res?.data?.menu);
          localStorage.removeItem(`${this.env.panel}menu`);
          localStorage.setItem(`${this.env.panel}menu`, JSON.stringify(res?.data?.menu));
          this.menu = res?.data?.menu;
          this.genMenuItems();
          this._shared.emitSideMenu({ menuAPICall: true });
        }
      },
      (err) => {
        console.log(err);
      });
  }

  closeSidebarIfOpen() {
    $('.sidebar-offcanvas').removeClass('active');
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  openLogin(e: any) {
    if (!this.isLogin()) {
      this._common.openModalWithComponent({ isDemoLoginComp: false }, LoginComponent, 'modal-dialog-centered login-popup')
    }
  }
  openSignUpModal(e: any) {
    this._common.openModalWithComponent({ signUpModal: true }, LoginComponent, 'modal-dialog-centered signup_modal')
  }

  logOut() {
    this.getServices().Get(`${this.env.baseUrl + this.api.logout}`).subscribe(
      (res) => {
        this._common.removeLocalstorage();
        this._message.succmessage(res.message);
        this.router.navigate(['/home']);
        //window.location.reload();
        setTimeout(function () {
          window.location.reload();
        }, 2000);

      },
      (err) => {
        console.log(err);
      });
  }

  openRightBar() {
    $('#rightsidebar').show();
    $('body').addClass("rightsidebar-open");
  }

  closeRightBar() {
    $('#rightsidebar').hide();
    $('body').removeClass("rightsidebar-open");
  }

  redirectCasinoWithTabSelection(event_type_id: any, pTabId: any): void {
    this.router.navigate(['/casino', event_type_id], { queryParams: { pId: pTabId, cId: 0 } });
  }


  confirmBox(item: any) {
    if (this.isLogin()) {
      item['multiplier'] = 100;
      let msg = `Profit & amp; Loss in iCasino would be ${item?.multiplier} times.It means, if you WIN 1, your Account Statement would be Credited as ${item?.multiplier} and similarly if you LOSE 1, your Account Statement would be Debited as ${item?.multiplier}. <br> Please note(1 Point = ${item?.multiplier} Points) <br> कृपया ध्यान दें(1 अंक = ${item?.multiplier} अंक)`;
      Swal.fire({
        title: 'DO YOU AGREE?',
        html: msg,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, I Agree',
        cancelButtonText: 'No, I dont Agree'
      }).then((result) => {
        if (result.value) {
          this.router.navigate([`/casino-detail`, 99995, item.id]);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
        }
      })
    } else {
      this.openLogin('')
    }
  }
  checkRedirectedFromSignup() {
    this.actRoute.queryParams.subscribe(params => {
      if (params['login']) {
        this.isIn = true;

        this.openLogin('');
      }
    });

  }

  getContactInfo() {
    this.userData = this.getLocalItem('user');
    // if (this.userData.username.toLowerCase() == this.env.demoLoginUserName) {
    //   // this.wpLink = this.env.host.demoLoginWpLink != '' ? this.env.host.demoLoginWpLink : this.wpLink;
    //   // this.env.demoDWLink = this.env.host.demoDepoWithdrawLink != '' ? this.env.host.demoDepoWithdrawLink : this.env.demoDWLink;
    //   this.contactInfoApi('demo');
    // } else {
    if (this.depoWithdrawCondition() || this.userData.username.toLowerCase() == this.env.demoLoginUserName) {
      // let url = `https://reddypanel.com/contact/reddybook.club/358417/Jnq8MNgo9g5R2SCDf8d35db89cdcdfc9d975bd67e0309d22`; //testURL
      this.contactInfoApi('');
    }
    // }
  }
  contactInfoApi(key: any) {
    if (this.userData.contact_info != '') {
      let url = this.userData.contact_info.replace(':domain', this.env.host.domain);
      this.getServices().Get(url).subscribe(
        (res) => {
          if (res?.error == 0) {
            this.wpLink = res?.link;
            this.env.demoDWLink = res?.link;
          }
        },
        (err) => {
          console.log(err);
        });
    }
  }

  hideDwnApk() {
    this.downloadDivStatus = false;
    this.setLocalItem('dwnApk', 1);
  }

  ngAfterViewInit() {
    this.userData = this.getLocalItem('user');
    if (localStorage.getItem(`${this.env.panel}JustL`) && this.userData?.username != 'demo123' && this.env.host.afterLoginNoticePath != '') {
      this.showAfterLoginModal();
      // localStorage.removeItem(`${this.env.panel}JustL`);
    }
  }

  ngDoCheck() {
    this.user = (localStorage.getItem(`${this.env.panel}user`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}user`) as any) : '';
    this.isLoggedin = (localStorage.getItem(`${this.env.panel}id_token`) && localStorage.getItem(`${this.env.panel}user`)) ? true : false;
    // let dts = (localStorage.getItem(`${this.env.panel}sideMenu`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}sideMenu`) as any) : [];
    // this.searchData = dts;
    if (this.isChatIn == false && this._common.getToken()) {
      this.isChatIn = true;
      this.userData = this.getLocalItem('user');
      this.getContactInfo();
    }
  }
  isIn: boolean = false;
  ngAfterContentChecked() {

    if (this.isIn == false) {
      this.checkRedirectedFromSignup();
    }

  }
  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }

}
